import { Outlet, createFileRoute } from '@tanstack/react-router';

import { FolderListPanel } from '../-components/folder-list-panel';
import { SearchResultsPanel } from '../-components/search-results-panel';

export const Route = createFileRoute('/_dashboard/mailbox/sent')({
  component: SentMailboxRoute,
});

// Sent keeps its own tree: a sent message is read in its conversation, not as a
// standalone row like spam and trash. Routing stays here; the panel is handed a
// link builder.
function SentMailboxRoute() {
  const { q } = Route.useSearch();
  const panel = q.trim() ? (
    <SearchResultsPanel />
  ) : (
    <FolderListPanel
      folder="sent"
      buildEmailLink={(emailId: string) => ({
        to: '/mailbox/sent/$emailId',
        params: { emailId },
      })}
    />
  );

  return (
    <div className="flex h-full overflow-hidden">
      {panel}
      <Outlet />
    </div>
  );
}
